const resultsENUM = [
  { id: 0, name: "Normal" },
  { id: 1, name: "Alterado" },
];

const reasonsENUM = [
  { id: 0, name: "Temperatura" },
  { id: 1, name: "Sintoma" },
  { id: 2, name: "AI" },
  { id: 3, name: "Índice" },
];

const statusMyListsENUM = [
  { id: 0, name: "Em processamento" },
  { id: 1, name: "Concluído" },
  { id: 2, name: "Erro" },
];

const panelTypesMyListsENUM = [
  { id: 0, name: "Cliente" },
  { id: 1, name: "Científico" },
];

const progressENUM = [
  { id: 0, name: "Incompleto" },
  { id: 1, name: "Completo" },
];

const statusENUM = [
  { id: 0, name: "Ativo", checked: true },
  { id: 1, name: "Inativo", checked: false },
];

const reportGenerationStatusENUM = [
  { id: 1, name: "Sim", checked: false },
  { id: 0, name: "Não", checked: false },
];

const collectTypesENUM = [
  { id: 1, name: "Científico" },
  { id: 2, name: "Laudo" },
  { id: 3, name: "Ambos" },
];

const booleanStatusENUM = [
  { id: true, name: "Ativo" },
  { id: false, name: "Inativo" },
];

const reportStatusENUM = [
  {
    color: "#D2FFE5",
    description: "Análise com laudo gerado",
    reportLabel: "Visualizar",
    id: 1,
  },
  {
    color: "#ffc768",
    description: "Análise com laudo processando",
    reportLabel: "Gerando",
    id: 3,
  },
  {
    color: "#FFF8BB",
    description: "Análise com diagnóstico",
    reportLabel: "Gerar",
    id: 2,
  },
  {
    color: "#FFFFFF",
    description: "Análise sem laudo e diagnóstico",
    reportLabel: "Esta análise não possui diagnóstico",
    id: 0,
  },
];

const initialFiltersClient = {
  companyIds: [],
  devices: [],
  periodFrom: "",
  periodTo: "",
  results: [],
  reasons: [],
  textSearch: "",
  progress: [],
  page: 1,
};

const initialFlowFiltersClient = {
  companyIds: [],
  devices: [],
  segments: [],
  reportStatuses: [],
  periodFrom: "",
  periodTo: "",
  results: [],
  reasons: [],
  textSearch: "",
  progress: [],
  page: 1,
};

const initialFiltersMyListsScreenings = {
  status: [],
  periodFrom: "",
  periodTo: "",
  codeOrName: "",
  panelTypes: [],
  page: 1,
};

const initialFiltersCustomers = {
  status: [0],
  collectTypes: [],
  textSearch: "",
  page: 1,
};

const initialCustomerValues = {
  company: {
    companyName: "",
    companyTag: "",
    companyEmail: "",
    contactName: "",
    contactEmail: "",
    companyTypeId: null,
    companyStatus: null,
  },
  files: {
    logo: "",
    waterMark: "",
  },
};

const initialFiltersCustomerUsers = {
  companyId: null,
  status: [1],
  textSearch: "",
  page: 1,
};

const initialFiltersCustomerAnydesks = {
  companyId: null,
  status: [1],
  textSearch: "",
  page: 1,
};

const initialCustomerUsersValues = {
  userName: "",
  userEmail: "",
  userStatus: null,
};

const initialCustomerAnydesksValues = {
  anydeskName: "",
  anydeskSerial: "",
  status: null,
};

const initialCustomerNewCompaniesValues = {
  companyId: 0,
  companyName: ""
};

const initialReportValuesStructure = {
  screeningId: "",
  reportTypeId: "",
  examDate: "",
  requester: {
    name: "",
    councilTypeId: "",
    councilNumber: "",
  },
  examiner: {
    name: "",
    councilTypeId: "",
    councilNumber: "",
  },
  evaluator: {
    name: "",
    councilTypeId: "",
    councilNumber: "",
  },
};

const FIELD_TYPE_OPTIONS = [
  { value: "text", label: "Texto" },
  { value: "textarea", label: "Texto longo" },
  { value: "checkbox", label: "Checkbox" },
  { value: "radio", label: "Radio" },
  { value: "select", label: "Seleção" },
  { value: "slider", label: "Slider" },
  { value: "summary", label: "Resumo" },
  { value: "image_click", label: "Clique na imagem" },
  { value: "thermal_capture", label: "Captura térmica" },
];

const FIELD_MASK_OPTIONS = [
  { value: "none", label: "Nenhuma", pattern: "", placeholder: "" },
  {
    value: "cpf",
    label: "CPF",
    pattern: "\d{3}\.\d{3}\.\d{3}-\d{2}",
    placeholder: "000.000.000-00",
  },
  {
    value: "cnpj",
    label: "CNPJ",
    pattern: "\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}",
    placeholder: "00.000.000/0000-00",
  },
  {
    value: "cep",
    label: "CEP",
    pattern: "\d{5}-\d{3}",
    placeholder: "00000-000",
  },
  {
    value: "phone",
    label: "Telefone",
    pattern: "\(\d{2}\) \d{4,5}-\d{4}",
    placeholder: "(00) 00000-0000",
  },
  {
    value: "date",
    label: "Data",
    pattern: "\d{2}\/\d{2}\/\d{4}",
    placeholder: "00/00/0000",
  },
  { value: "custom", label: "Personalizada", pattern: "", placeholder: "" },
];

const SCREENING_TYPE_OPTIONS = [
  { value: 1, label: "Covid" },
  { value: 2, label: "Termografia Segmentada" },
  { value: 3, label: "Termografia de Corpo Inteiro" },
  { value: 4, label: "Dor de Cabeça / Cefaléia" },
  { value: 5, label: "Termografia das Mamas" },
  { value: 6, label: "Demonstração" },
  { value: 7, label: "Fazenda" },
  { value: 8, label: "Oftalmológica" },
  { value: 9, label: "Arboviroses" },
];

const initialFormValues = {
  name: "",
  description: "",
  version: "1.0",
  screeningType: "",
  isCurrent: false,
  steps: [],
};

const gaussianBlurSigma = 1.25;

export {
  resultsENUM,
  reasonsENUM,
  statusMyListsENUM,
  panelTypesMyListsENUM,
  progressENUM,
  statusENUM,
  reportGenerationStatusENUM,
  booleanStatusENUM,
  collectTypesENUM,
  reportStatusENUM,
  initialFiltersClient,
  initialFlowFiltersClient,
  initialFiltersMyListsScreenings,
  initialFiltersCustomers,
  initialCustomerValues,
  initialFiltersCustomerUsers,
  initialCustomerUsersValues,
  initialFiltersCustomerAnydesks,
  initialCustomerAnydesksValues,
  initialCustomerNewCompaniesValues,
  initialReportValuesStructure,
  FIELD_TYPE_OPTIONS,
  FIELD_MASK_OPTIONS,
  SCREENING_TYPE_OPTIONS,
  initialFormValues,
  gaussianBlurSigma
};
